// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".MemberModal_modal-content__ZWwKu button{margin-top:2rem}", "",{"version":3,"sources":["webpack://./src/modals/MemberModal.scss"],"names":[],"mappings":"AACE,yCACE,eAAA","sourcesContent":[".modal-content {\n  button {\n    margin-top: 2rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modal-content": "MemberModal_modal-content__ZWwKu"
};
export default ___CSS_LOADER_EXPORT___;
